export const mdrdevelopment = {
  production: false,
  name: "mdrdevelopment",
  useEmulators: false,
  commit: 'mdrdevelopmentcommit',
  firebase: {
    apiKey: 'AIzaSyCYBtdiohWAshYczDL_cwt60O88lW2Hl9E',
    authDomain: 'segui-staging.firebaseapp.com',
    databaseURL: 'https://segui-staging.firebaseio.com',
    projectId: 'segui-staging',
    storageBucket: 'segui-staging.appspot.com',
    messagingSenderId: '778797287828',
    appId: '1:778797287828:web:e4bb6494dd440b97566781',
    measurementId: 'G-ZBQZ1G03L0',
  },
  urls: {
    segue: 'http://localhost:4200',
    segui: 'http://localhost:4201',
    xview: 'http://localhost:4202',
    console: 'http://localhost:4203',
    // meshBaseUrl:'/assets/models', // for testing local mesh generation
    meshBaseUrl: 'https://storage.googleapis.com/3d-segui-staging/models',
  }
};
